import { render } from "./slide16.vue?vue&type=template&id=701f663e&scoped=true"
import script from "./slide16.vue?vue&type=script&lang=js"
export * from "./slide16.vue?vue&type=script&lang=js"

import "./slide16.vue?vue&type=style&index=0&id=701f663e&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701f663e"]])

export default __exports__